import { useState } from "react";
import { nf } from "./shared";

const STATI = [
  ["probabile", "Verificato", "text-emerald-300"], ["parziale", "Da verificare", "text-amber-400"],
  ["non_determinabile", "Non determinabile", "text-orange-400"], ["dati_mancanti", "Dati mancanti", "text-red-400"], ["in_analisi", "In analisi", "text-neutral-400"],
];

export function ConsumiStati({ list = [], onOpen }) {
  const [sel, setSel] = useState(null);
  const conta = (k) => list.filter((r) => r.stato === k).length;
  const righe = sel ? list.filter((r) => r.stato === sel) : [];
  return (
    <div className="space-y-2 rounded-xl border border-neutral-800 p-3 text-xs" data-testid="consumi-stati">
      <div className="text-neutral-400">Stato consumi per impianto <span className="text-neutral-600">(tocca uno stato per vedere l'elenco)</span></div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        {STATI.map(([k, lab, col]) => (
          <button key={k} type="button" onClick={() => setSel(sel === k ? null : k)} data-testid={`consumi-stato-${k}`}
            className={`rounded-lg border px-3 py-2 text-left transition-colors ${sel === k ? "border-neutral-400 bg-white/5" : "border-neutral-800 hover:border-neutral-600"}`}>
            <div className="text-neutral-500">{lab}</div><b className={`font-mono text-lg ${col}`} data-testid={`consumi-stato-${k}-count`}>{conta(k)}</b>
          </button>
        ))}
      </div>
      {sel && (
        <div className="max-h-72 divide-y divide-neutral-900 overflow-y-auto rounded-lg border border-neutral-800" data-testid="consumi-stati-lista">
          {righe.map((r) => (
            <button key={r.id} type="button" onClick={() => onOpen?.(r.id)} data-testid={`consumi-row-${r.id}`}
              className="flex w-full flex-wrap items-center gap-x-3 gap-y-1 px-3 py-2 text-left transition-colors hover:bg-white/5">
              <b className="text-white">{r.nome}</b><span className="text-neutral-500">{r.partner} · {nf(r.kwp)} kWp</span>
              {r.motivo && <span className="w-full text-neutral-400">{r.motivo}</span>}
            </button>
          ))}
          {!righe.length && <p className="p-3 text-center text-neutral-500">Nessun impianto in questo stato.</p>}
        </div>
      )}
    </div>
  );
}
